/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum EventName {
  APP_START='APP_START',
  APP_FOREGROUND='APP_FOREGROUND',
  APP_BACKGROUND='APP_BACKGROUND',
  LOGIN='LOGIN',
  LOGOUT='LOGOUT',
  TnC='TnC',
  SEARCH='SEARCH',
  CREATE_PROFILE='CREATE_PROFILE',
  UPDATE_PROFILE='UPDATE_PROFILE',
  REMOVE_DEVICE='REMOVE_DEVICE',
  VIEW_CONTENT_DETAILS='VIEW_CONTENT_DETAILS',
  GAME_CLICKED='GAME_CLICKED',
  RENT_CONTENT='RENT_CONTENT',
  APP_UPDATE='APP_UPDATE',
  FAVORITE_CONTENT='FAVORITE_CONTENT',
  STOREFRONT_TAB_CHANGE='STOREFRONT_TAB_CHANGE',
  MENU_TAB_CHANGE='MENU_TAB_CHANGE',
  VIEW_COLLECTION_DETAILS='VIEW_COLLECTION_DETAILS',
  VIEW_PLANS='VIEW_PLANS',
  SUBSCRIPTION_INITIATED='SUBSCRIPTION_INITIATED',
  PAYMENT_INITIATED='PAYMENT_INITIATED',
  VOTE_NOW='VOTE_NOW',
  NETWORK_CHANGE='NETWORK_CHANGE',
  ERROR='ERROR',
  BANNER_AD_CLICK='BANNER_AD_CLICK',
  LINK_TO_MOBILE='LINK_TO_MOBILE',
  LINK_TO_EMAIL='LINK_TO_EMAIL',
}